import { AvailableLocale } from '@omnea-digital/toolbox'
import { CurrencyCode, isCurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'
import { getISOCode } from './getISOCode'

export const getCurrencySymbol = (currency: CurrencyCode, locale: AvailableLocale): string => {
  const { code } = getISOCode(currency)
  const parts = new Intl.NumberFormat(locale, { style: 'currency', currency: code }).formatToParts(0)
  return parts.find((p) => p.type === 'currency')?.value ?? code
}

export const formatMonetaryAmount = (
  amount: number,
  currency: CurrencyCode,
  locale: AvailableLocale,
  options: Omit<Intl.NumberFormatOptions, 'style' | 'currency'> = { maximumFractionDigits: 2, minimumFractionDigits: 2 }
) => {
  // TODO: make this better
  if (!currency) {
    return ''
  }

  const { code } = getISOCode(currency)

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    ...options,
  }).format(amount)
}

// Null when the value can't be shown as money (no amount, or no valid currency); the caller renders its own empty state.
export const formatMoney = (
  amount: number | null | undefined,
  currency: string | null | undefined,
  locale: AvailableLocale
): string | null => {
  if (amount == null || !isCurrencyCode(currency)) return null
  return formatMonetaryAmount(amount, currency, locale)
}
